export default (state = {
    submittingForm: false,
}, action) => {
    switch (action.type) {
        case 'FORM_SUBMITTING_CHANGE_STATUS' :
            return {
                ...state,
                submittingForm: action.status
            };
        default:
            return state;
    }
};
